import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map, catchError } from "rxjs/operators";
import { Observable , throwError } from 'rxjs';
import { PriceDTO, StockDTO } from '@signature-it/ngx-catalogue/models';
import { RestUrlsConfig} from "@signature-it/ngx-generic/config";
import {CommonService, PageNotificationService} from "@signature-it/ngx-generic/services";
declare let _: any;

@Injectable({
    providedIn: 'root'
})
// PriceService
export class ProductService extends CommonService {

    constructor(http: HttpClient, restUrlsConf: RestUrlsConfig, notifySvc: PageNotificationService) {
        super(http, restUrlsConf, notifySvc);
    }

    protected baseUrl = this.restUrlsConf.appURL;
    protected publicBaseUrl = `${this.restUrlsConf.appURL}/public`;

    protected pUrl = `${this.publicBaseUrl}/product`;
    protected pTotalDataUrl = `${this.restUrlsConf.appURL}/admin/product/getTotalData.json`;
    protected pTotalMediaTypes = `${this.restUrlsConf.appURL}/admin/product/getTotalMediaTypes.json`;
    protected pTotalGroups = `${this.restUrlsConf.appURL}/admin/gadget/get-bar-data?type=groups`;

    /**
     * @param productIds<Array>
     * @returns Observable<PriceDTO[]>
     */
    getPrice(productIds:any) {
        const pIds = productIds.join();
        return this.http.get(`${this.pUrl}/${pIds}/price.json`)
            .pipe(map((data: any) => PriceDTO.createFromArray(data)), catchError(error => throwError(error)));
    }

    getStock(productCodes:any) {
        let pIds = productCodes.join();
        pIds = encodeURIComponent(pIds);
        return this.http.get(`${this.pUrl}/stock.json?productsList=${pIds}`)
            .pipe(map((data: any) => StockDTO.createFromArray(data)), catchError(error => throwError(error)));
    }

    getTotalProductData(distributionChannelIds): Observable<string> {
        return this.http.get<string>(`${this.pTotalDataUrl}?distribution_channel_list=${distributionChannelIds.join()}`);
    }

    getTotalMediaTypes(distributionChannelIds): Observable<string> {
        return this.http.get<string>(`${this.pTotalMediaTypes}?distribution_channel_list=${distributionChannelIds.join()}`);
    }

    getTotalGroups(distributionChannelIds): Observable<string> {
        return this.http.get<string>(`${this.pTotalGroups}`);
    }
}
